<template>
  <div class="container mt-5">
    <div class="columns is-centered">
      <div class="column is-half">
        <h1 class="title">My Account</h1>

        <div v-if="loadingUser" class="has-text-centered">
          <button class="button is-loading is-white">
            Loading
          </button>
        </div>

        <form v-else @submit.prevent="submitForm">
          <div v-if="successMessage" class="notification is-success">
            {{ successMessage }}
          </div>

          <div v-if="errors.length" class="notification is-danger">
            <ul>
              <li v-for="error in errors" :key="error">
                {{ error }}
              </li>
            </ul>
          </div>

          <div class="box mb-5">
            <div class="field">
              <label class="label">Your Name</label>

              <div class="control">
                <input
                  v-model="user.first_name"
                  class="input"
                  type="text"
                >
              </div>
            </div>
          </div>

          <div class="box">
            <h2 class="title is-5">
              Login Credentials
            </h2>

            <div class="notification is-warning is-light mb-4">
              <span class="icon-text">
                <span class="icon">
                  <i class="fas fa-info-circle"></i>
                </span>

                <span>
                  Your email &amp; password must match your
                  ServiceM8 login credentials.
                </span>
              </span>
            </div>

            <div class="field">
              <label class="label">Email</label>

              <div class="control">
                <input
                  v-model="user.email"
                  class="input"
                  type="email"
                  disabled
                >
              </div>
            </div>

            <div class="field">
              <label class="label">New Password</label>

              <div class="control">
                <input
                  v-model="user.password"
                  class="input"
                  type="password"
                  placeholder="Leave blank to keep existing password"
                >
              </div>
            </div>

            <div class="field">
              <label class="label">Repeat New Password</label>

              <div class="control">
                <input
                  v-model="user.repeat_password"
                  class="input"
                  type="password"
                  placeholder="Repeat new password"
                >
              </div>
            </div>
          </div>

          <div class="field is-grouped is-justify-content-flex-end mt-5">
            <div class="control">
              <router-link to="/" class="button is-light">
                Cancel
              </router-link>
            </div>

            <div class="control">
              <button
                class="button is-primary"
                :class="{ 'is-loading': saving }"
                :disabled="saving"
              >
                Save Changes
              </button>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'MyAccountView',

  data() {
    return {
      loadingUser: true,
      saving: false,
      successMessage: '',
      errors: [],

      user: {
        id: null,
        first_name: '',
        email: '',
        password: '',
        repeat_password: ''
      }
    }
  },

  computed: {
    currentUser() {
      return this.$store.state.user
    }
  },

  async mounted() {
    await this.initialise()
  },

  methods: {
    async initialise() {
      this.loadingUser = true
      this.errors = []

      try {
        const userId = this.currentUser.id

        const response = await axios.get('/api/v1/me/')

        this.user = {
          id: response.data.id,
          first_name: response.data.first_name,
          email: response.data.email,
          password: ''
        }
      } catch (error) {
        console.error(error)
        this.errors.push('Failed to load account details')
      } finally {
        this.loadingUser = false
      }
    },

    async submitForm() {
      this.errors = []
      this.successMessage = ''

      if (!this.user.first_name) {
        this.errors.push('Your name is required.')
      }

      if (this.user.password || this.user.repeat_password) {
        if (this.user.password !== this.user.repeat_password) {
          this.errors.push('Passwords do not match.')
        }
      }

      if (this.errors.length) {
        return
      }

      this.saving = true

      try {
        const payload = {
          first_name: this.user.first_name
        }

        if (this.user.password) {
          payload.password = this.user.password
          payload.repeat_password = this.user.repeat_password
        }

        const response = await axios.patch(
          '/api/v1/me/',
          payload
        )

        this.user.password = ''
        this.user.repeat_password = ''

        this.successMessage =
          'Account details updated successfully.'

        this.$store.commit('setUser', response.data)

      } catch (error) {
        console.error(error)
        this.handleApiErrors(error)
      } finally {
        this.saving = false
      }
    },

    handleApiErrors(error) {
      if (error.response && error.response.data) {
        const data = error.response.data

        Object.keys(data).forEach((field) => {
          const messages = data[field]

          if (Array.isArray(messages)) {
            messages.forEach(message => {
              this.errors.push(message)
            })
          } else {
            this.errors.push(messages)
          }
        })
      } else {
        this.errors.push('Failed to update account details.')
      }
    }
  }
}
</script>